import { BASE_URL } from 'config';
import { useEffect, useState } from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import DataTable from "examples/Tables/DataTable";
import storesOrdersTableData from "./data/storesOrdersTableData";
import TextField from "@mui/material/TextField";
import MDButton from "components/MDButton";
import AddIcon from "@mui/icons-material/Add";
import { Height } from "@mui/icons-material";
import { Box, Grid, width } from "@mui/system";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import OrdersDetailsDialog from "./ordersDetailsDialog";
import RoomIcon from "@mui/icons-material/Room";
import { CircularProgress, Backdrop, Typography } from "@mui/material";
import RowsPerPageSelector from "components/RowsPerPageSelector";
import Button from "@mui/material/Button";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useNavigate } from "react-router-dom";
import TagIcon from '@mui/icons-material/Tag';
function StoresOrders() {
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [detailsDialogOpen, setDetailsDialogOpen] = useState(false);
  const [selectedSubOrder, setSelectedSubOrder] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const handleEditClick = (user) => {
    setCurrentUser(user);
    setModalOpen(true);
  };

  useEffect(() => {

    fetchUsers(pageNumber);

  }, [pageNumber]);

  const fetchUsers = async (pageNumber) => {
    setLoading(true);
    const token = localStorage.getItem("user-token");
    try {
      const response = await fetch(
        `${BASE_URL}/administrator/orders?page=${pageNumber}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await response.json();
      setUsers(data.data || []);
      setRowsPerPage(data.per_page || 10);
      setTotalPages(data.last_page || 1); // ←
      console.log(data.data);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
    setLoading(false);
  };

  const renderSubStoreOrders = (orderStores) => {
    console.log("orderStores", orderStores);
    if (!orderStores) return null;
    return orderStores.map((storeOrder) => (
      <MDBox key={storeOrder.id} mt={2} p={2} border={1} borderColor="grey.300" borderRadius="lg">
        <MDTypography variant="subtitle2">
          Store: {storeOrder.store.name_ar} ({storeOrder.store.name_en})
        </MDTypography>
        <MDTypography variant="body2">Total Price: {storeOrder.total_price}</MDTypography>
        <MDTypography variant="body2">Tax Total: {storeOrder.tax_total}</MDTypography>
        <MDTypography variant="body2">Status: {storeOrder.status}</MDTypography>
      </MDBox>
    ));
  };

  const { columns, rows } = storesOrdersTableData(users, handleEditClick, fetchUsers);

  const enhancedRows = rows.map((row) => ({
    ...row,
    subStoreOrders: renderSubStoreOrders(row.order_store),
  }));

  const filteredRows = enhancedRows.filter((row) => row.order_number.toString().includes(search));

  const paginatedRows = filteredRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  console.log("paginated orders :", paginatedRows)
  useEffect(() => {
    setPage(0); // تصفير الصفحة عند تغيير البحث أو عدد الصفوف
  }, [search, rowsPerPage]);

  const handleOrderStatusChange = async (orderId, newStatus) => {
    try {
      const token = localStorage.getItem("user-token");
      await fetch(`${BASE_URL}/administrator/orders/${orderId}/status`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ status: newStatus }),
      });
      fetchUsers(pageNumber);
    } catch (error) {
      alert("حدث خطأ أثناء تحديث الحالة");
    }
  };

  return (
    <>
      <Backdrop open={loading} sx={{ zIndex: 2000, color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <MDBox pt={6} pb={3}>
        <Card>
          <MDBox
            mx={2}
            mt={-3}
            py={3}
            px={2}
            borderRadius="lg"
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            sx={{
              background: "linear-gradient(90deg, #ca9937, #e0b15a)",
              boxShadow: 3,
            }}
          >
            <MDTypography variant="h6" color="white">
              قائمة الطلبات
            </MDTypography>
          </MDBox>

          <MDBox pt={3} px={2}>
            <Box display="flex" gap={2} alignItems="center">


              <TextField
                fullWidth
                label="بحث برقم الطلب "
                variant="outlined"
                size="small"
                sx={{ mb: 3 }}
                onChange={(e) => setSearch(e.target.value)}
              />
              {/* مكون اختيار عدد الصفوف */}
              <MDBox mb={2} display="flex">
                <RowsPerPageSelector value={rowsPerPage} onChange={setRowsPerPage} />
              </MDBox>
            </Box>
            {/* عرض الطلبات كبطاقات */}

          </MDBox>
        </Card>
      </MDBox>
      <Grid container spacing={2}>
        {paginatedRows.map((row, idx) => {
          console.log("Order ID:", row.order_number, "Status:", row.status);
          // بيانات العنوان
          const address = row.customer_addresse;
          const location = address?.location_hierarchy || {};
          return (

            <Grid item key={idx} size={{ xs: 12, md: 4 }}>
              <Card sx={{ mb: 4, p: 3, boxShadow: 3 }}>
                {/* بطاقة عنوان العميل */}
                {address && (
                  <MDBox
                    display="flex"
                    alignItems="center"
                    gap={2}
                    mb={3}
                    sx={{
                      background: "linear-gradient(90deg, #e0b15a, #ca9937)",
                      borderRadius: 3,
                      p: 2,
                      boxShadow: 2,
                      color: "white",
                      flexWrap: "wrap",
                    }}
                  >
                    <RoomIcon sx={{ fontSize: 36, color: "#fff" }} />
                    <MDBox>
                      <MDTypography variant="h6" color="white" fontWeight="bold">
                        {address.name}
                        <span style={{ fontSize: 14, color: "#f5f5f5" }}>
                          ({address.phone})
                        </span>
                      </MDTypography>
                      <MDTypography variant="body2" color="white">
                        الدولة: {location.country?.name || "-"} | المنطقة:{" "}
                        {location.state?.name || "-"} | المدينة:{" "}
                        {location.province?.name || "-"}
                      </MDTypography>
                      <MDTypography variant="body2" color="white">
                        العنوان: {address.address || "-"}
                      </MDTypography>
                      <MDTypography variant="body2" color="white">
                        الرمز البريدي: {address.zip_code || "-"}
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                )}
                {/* زر معاينة التفاصيل */}

                <MDBox
                  display="flex"
                  flexDirection="column"

                  gap={2}
                  mb={2}

                >
                  <Box display="flex" alignItems="center" gap={1}>
                    <TagIcon sx={{ fontSize: 20 }} color='text' />
                    <Typography variant="body1" color='primary' > {row.order_number}</Typography>
                  </Box>
                  <MDBox>
                    <MDTypography variant="body1">العميل: {row.customer}</MDTypography>
                  </MDBox>
                  <MDBox>
                    <MDTypography variant="body1">الاجمالي: {row.total_amount}</MDTypography>
                  </MDBox>
                  <MDBox>
                    <Typography variant="body1" color='text'  >
                      حالة الدفع: {row.payment_status}
                    </Typography>
                  </MDBox>

                  <MDBox display="flex" alignItems="center" gap={1} >
                    <Typography
                      variant="subtitle2"
                      fontWeight="bold"
                      color="text"

                    >
                      حالة الطلب
                    </Typography>
                    <FormControl
                      fullWidth
                      size="small"
                      sx={{ maxWidth: "150px", background: "secondary", borderRadius: "8px" }}
                    >
                      <InputLabel id={`order-status-label-${row.order_number}`}>
                        حالة الطلب
                      </InputLabel>
                      <Select
                        labelId={`order-status-label-${row.order_number}`}
                        id={`order-status-select-${row.order_number}`}
                        value={row.status}
                        label="حالة الطلب"
                        onChange={(e) => handleOrderStatusChange(row.id, e.target.value)}
                        sx={{ height: 35 }}
                      >
                        <MenuItem value="pending">قيد الانتظار</MenuItem>
                        <MenuItem value="confirm">قيد التنفيذ</MenuItem>
                        <MenuItem value="shipped">قيد الشحن</MenuItem>
                        <MenuItem value="delivered">تم التسليم</MenuItem>
                        <MenuItem value="cancelled">ملغي</MenuItem>
                        {/* <MenuItem value="refunded">مسترجع</MenuItem> */}
                      </Select>
                    </FormControl>
                  </MDBox>
                </MDBox>
                <Button
                  variant="outlined"
                  color="secondary"
                  startIcon={<VisibilityIcon />}
                  sx={{
                    fontWeight: "bold",
                    px: 2,
                    color: "primary.main",
                    borderRadius: 2,
                    boxShadow: 2,
                    textTransform: "none",
                    fontSize: 16,
                    transition: "all 0.2s",
                    "&:hover": {
                      backgroundColor: "primary.focus",
                      color: "#fff",
                      boxShadow: 4,
                      transform: "scale(1.04)",
                    },
                    mt: 2,
                  }}
                  onClick={() => navigate(`/stores_orders/details/${row.order_number}`)}
                >
                  معاينة التفاصيل
                </Button>
                {/* الطلبات الفرعية */}
                {Array.isArray(row.order_store) && row.order_store.length > 0 && (
                  <MDBox>
                    <MDTypography variant="subtitle1" fontWeight="bold" mb={1}>
                      الطلبات الفرعية:
                    </MDTypography>
                    <MDBox display="flex" flexWrap="wrap" gap={2}>
                      {row.order_store.map((sub) => (
                        <Card
                          key={sub.id}
                          sx={{
                            p: 2,
                            minWidth: 220,
                            background: "#f9f9f9",
                            position: "relative",
                          }}
                        >
                          <MDTypography variant="subtitle2" fontWeight="bold">
                            المتجر: {sub.store.name_ar} ({sub.store.name_en})
                          </MDTypography>
                          <MDTypography variant="subtitle2" fontWeight="bold">
                            رقم الطلب: {sub.id}
                          </MDTypography>
                          <MDBox display="flex" alignItems="center" gap={1} mt={1} mb={1}>
                            <MDTypography
                              variant="subtitle2"
                              fontWeight="bold"
                              sx={{ whiteSpace: "nowrap" }}
                            >
                              حالة الطلب
                            </MDTypography>
                            <FormControl
                              fullWidth
                              size="small"
                              sx={{ maxWidth: "150px", background: "#fff", borderRadius: 2 }}
                            >
                              <Select
                                labelId={`order-status-label-${sub.id}`}
                                id={`order-status-select-${sub.id}`}
                                value={sub.status}
                                label="حالة الطلب"
                                onChange={(e) =>
                                  handleOrderStatusChange(sub.id, e.target.value)
                                }
                                sx={{ height: 30 }}
                              >
                                <MenuItem value="pending">قيد الانتظار</MenuItem>
                                <MenuItem value="confirmed">قيد التنفيذ</MenuItem>
                                <MenuItem value="shipping">قيد الشحن</MenuItem>
                                <MenuItem value="delivered">مكتمل</MenuItem>
                                <MenuItem value="cancelled">ملغي</MenuItem>
                              </Select>
                            </FormControl>
                          </MDBox>
                          <MDTypography variant="body2">السعر: {sub.total_price}</MDTypography>
                          <MDTypography variant="body2">الضريبة: {sub.tax_total}</MDTypography>
                          <MDTypography variant="body2">
                            الخصم: {sub.total_discount}
                          </MDTypography>
                          <MDTypography variant="body2">الاجمالي: {sub.total}</MDTypography>
                          <MDTypography variant="body1" mb={1}>
                            تاريخ الطلب: {sub.created_at ? sub.created_at.slice(0, 10) : ""}
                          </MDTypography>
                          {sub.tracking_url && (
                            <MDTypography variant="body2">
                              <a
                                href={sub.tracking_url}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                تتبع الشحنة
                              </a>
                            </MDTypography>
                          )}
                          {/* زر تفاصيل الطلب */}
                          <MDBox display="flex" mt={2}>
                            <MDButton
                              variant="outlined"
                              color="info"
                              size="small"
                              onClick={() => {
                                setSelectedSubOrder(sub);
                                setDetailsDialogOpen(true);
                              }}
                            >
                              تفاصيل الطلب
                            </MDButton>
                          </MDBox>
                        </Card>
                      ))}
                    </MDBox>
                  </MDBox>
                )}
              </Card>
            </Grid>
          );
        })}
      </Grid>

      {/* أزرار التحكم في الصفحات */}
      <MDBox display="flex" justifyContent="center" mt={4} pb={4} px={2}>
        <MDButton
          onClick={() => {
            if (pageNumber > 1) {
              setPageNumber(pageNumber - 1);
            }
          }}
          disabled={pageNumber === 1}
          sx={{
            background: "linear-gradient(90deg, #ca9937, #e0b15a)",
            color: "white",
            borderRadius: "50%",
            width: "50px",
            height: "50px",
            minWidth: "50px",
            mx: 1,
            "&:hover": {
              background: "linear-gradient(90deg, #b6842f, #d39d45)",
            },
          }}
        >
          <ArrowBackIcon />
        </MDButton>

        <MDTypography
          variant="button"
          color="text"
          sx={{
            display: "flex",
            alignItems: "center",
            mx: 3,
            fontWeight: "bold",
          }}
        >
          الصفحة {pageNumber}
        </MDTypography>

        <MDButton
          onClick={() => {
            if (pageNumber < totalPages) {
              setPageNumber(pageNumber + 1);
            }
          }}
          disabled={pageNumber === totalPages}
          sx={{
            background: "linear-gradient(90deg, #ca9937, #e0b15a)",
            color: "white",
            borderRadius: "50%",
            width: "50px",
            height: "50px",
            minWidth: "50px",
            mx: 1,
            "&:hover": {
              background: "linear-gradient(90deg, #b6842f, #d39d45)",
            },
          }}
        >
          <ArrowForwardIcon />
        </MDButton>
      </MDBox>
      {/* Dialog لعرض تفاصيل الطلب الفرعي */}
      <OrdersDetailsDialog
        open={detailsDialogOpen}
        onClose={() => setDetailsDialogOpen(false)}
        subOrder={selectedSubOrder}
      />
    </>
  );
}

export default StoresOrders;
